import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=036d9052&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=js&"
export * from "./HomePage.vue?vue&type=script&lang=js&"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=036d9052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d9052",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036d9052')) {
      api.createRecord('036d9052', component.options)
    } else {
      api.reload('036d9052', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=036d9052&scoped=true&", function () {
      api.rerender('036d9052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/home/HomePage.vue"
export default component.exports